/**
 * ConfirmDialog — "are you sure?" before a step that cannot be undone.
 *
 *   <ConfirmDialog
 *     title="Unsaved Changes"
 *     message="You have unsaved changes. Are you sure you want to discard changes?"
 *     cancelLabel="No" confirmLabel="Yes" danger
 *     onConfirm={discard} onCancel={close} />
 *
 * Legacy repeats this dialog hand-built in several places (FooterActions.vue
 * Cancel and Delete Portfolio, the unsaved-changes prompt); one component
 * keeps the wording, button order and look the same everywhere. Built on the
 * design system's Modal, so it gets the app's dialog header (styles/global.css).
 *
 * Render it only while it should be open; `busy` disables both buttons while
 * the confirmed action runs. `persistent` (legacy v-dialog persistent): a
 * click outside or Esc does NOT close it — only its own buttons do. For a
 * choice that would be lost by an accidental click.
 */
import { Button, Modal } from '@components/ui';

import styles from './ConfirmDialog.module.css';

export function ConfirmDialog({
  title,
  message,
  confirmLabel = 'Yes',
  cancelLabel = 'No',
  danger = false,
  busy = false,
  persistent = false,
  onConfirm,
  onCancel,
}) {
  return (
    <Modal
      open
      onClose={busy || persistent ? () => {} : onCancel}
      title={title}
      footer={
        <div className={styles.actions}>
          <Button variant="secondary-solid" onClick={onCancel} disabled={busy}>
            {cancelLabel}
          </Button>
          <Button variant={danger ? 'danger' : 'primary'} onClick={onConfirm} loading={busy}>
            {confirmLabel}
          </Button>
        </div>
      }
    >
      <p className={styles.message}>{message}</p>
    </Modal>
  );
}

export default ConfirmDialog;
